import dpasaLogo from '~assets/dpasa.svg';
const CONFIGURATION = {
    name: 'Kalk',
    key: 'dpasa',
    motto: 'AI for Business',
    logo: dpasaLogo,
    linkPrivacyPolicy: 'https://unbounded.network/privacy',
    linkTermsOfUse: 'https://unbounded.network/terms',
};
export default CONFIGURATION;
